import { FaTrashCan } from 'react-icons/fa6'

interface InputGroupProps {
  initValue?: string
  header: string
  placeholder: string
  itemKey: string
  removeItem: (key: string) => void
  updateInputValue: (value: string) => void
}

export default function InputGroup(
  {
    initValue,
    header,
    placeholder,
    itemKey,
    removeItem,
    updateInputValue,
  }: InputGroupProps,
) {
  return (
    <div key={`container_${itemKey}`} className="flex gap-2 items-center">
      <div className="flex w-full">
        <div
          className="border border-r-0 border-gray-300 text-center px-5 py-2.5 bg-gray-100 w-32 text-sm rounded-l-lg rounded-r-none">
          {header}
        </div>
        <input
          defaultValue={initValue || ''}
          key={`input_${itemKey}`}
          onChange={(e) => updateInputValue(e.target.value)}
          placeholder={placeholder}
          className="border border-gray-300 text-gray-900 text-sm rounded-r-lg rounded-l-none focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          type="text"
        />
      </div>
      <FaTrashCan
        onClick={() => removeItem(itemKey)}
        className="ml-auto cursor-pointer"
        width={20}
        height={20}
      />
    </div>
  )
}
